import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// 12-hour time input with an AM/PM selector.
// `value`/`onChange` use the stored 24h "HH:MM" string (scheduling logic unchanged).
const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

function parse(value) {
  if (!value) return { h: '', m: '', mer: 'AM' };
  const [hh, mm] = String(value).split(':');
  const h = parseInt(hh, 10);
  const m = parseInt(mm, 10);
  if (isNaN(h)) return { h: '', m: '', mer: 'AM' };
  const mer = h < 12 ? 'AM' : 'PM';
  const h12 = (h % 12) || 12;
  return { h: String(h12), m: isNaN(m) ? '00' : String(m).padStart(2, '0'), mer };
}

export function TimePicker12({ value, onChange, testid }) {
  const { h, m, mer } = parse(value);
  const emit = (nh, nm, nmer) => {
    const hh = parseInt(nh, 10);
    if (isNaN(hh)) { onChange(''); return; }
    const mm = parseInt(nm ?? '0', 10) || 0;
    const M = nmer || 'AM';
    let h24 = hh % 12;
    if (M === 'PM') h24 += 12;
    onChange(`${String(h24).padStart(2, '0')}:${String(mm).padStart(2, '0')}`);
  };
  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      <Select value={h} onValueChange={v => emit(v, m || '00', mer)}>
        <SelectTrigger className="w-[70px]" aria-label="Hour" data-testid={testid ? `${testid}-hour` : undefined}><SelectValue placeholder="hh" /></SelectTrigger>
        <SelectContent className="max-h-60">{HOURS.map(x => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
      </Select>
      <span className="text-muted-foreground">:</span>
      <Select value={m} onValueChange={v => emit(h || '12', v, mer)}>
        <SelectTrigger className="w-[74px]" aria-label="Minute" data-testid={testid ? `${testid}-min` : undefined}><SelectValue placeholder="mm" /></SelectTrigger>
        <SelectContent className="max-h-60">{MINUTES.map(x => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={mer} onValueChange={v => emit(h || '12', m || '00', v)}>
        <SelectTrigger className="w-[74px]" aria-label="AM or PM" data-testid={testid ? `${testid}-mer` : undefined}><SelectValue /></SelectTrigger>
        <SelectContent><SelectItem value="AM">AM</SelectItem><SelectItem value="PM">PM</SelectItem></SelectContent>
      </Select>
    </div>
  );
}

export default TimePicker12;
